import React from "react";
import VendorBidGeneralRFQ from "./VendorBidGeneralRFQ";

const VendorViewGeneralRFQ = () => <VendorBidGeneralRFQ viewMode />;

export default VendorViewGeneralRFQ;
